import { render, staticRenderFns } from "./CoursesNumbers.vue?vue&type=template&id=bab8483a&scoped=true"
import script from "./CoursesNumbers.vue?vue&type=script&lang=ts"
export * from "./CoursesNumbers.vue?vue&type=script&lang=ts"
import style0 from "./CoursesNumbers.vue?vue&type=style&index=0&id=bab8483a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8483a",
  null
  
)

export default component.exports